const getActualPercentage = (maxValue, percentage) => {
    if (!percentage || percentage < 0)
        return 0;
    if (percentage > maxValue)
        return maxValue;
    return percentage;
};
export default getActualPercentage;
//# sourceMappingURL=getActualPercentage.js.map